import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { isValidPassengersNumber } from 'utils/validators';
import { Field, StyledInput } from 'pages/ManageClubEurostar/ManageClubEurostar.styles';
import Label from 'components/ui/Label';
import { MAX_NUMBER_OF_NON_WHEELCHAIR_COMPANIONS, MAX_NUMBER_OF_WHEELCHAIR_COMPANIONS } from 'constants/addPassengers';

const SpecialAssistanceBooking = ({ register, errors, hasWheelchairPassenger, hasWheelchairCompanion }) => (
  <>
    {hasWheelchairPassenger && !hasWheelchairCompanion ? (
      <Field>
        <Label htmlFor="wheelchairCompanions">
          <FormattedMessage id="addPassengers.wheelchairCompanions" />
        </Label>
        <StyledInput
          {...register('wheelchairCompanions', {
            validate: (value) => !value || (isValidPassengersNumber(value) && Number(value) <= MAX_NUMBER_OF_WHEELCHAIR_COMPANIONS)
          })}
          type="number"
          inputMode="numeric"
          id="wheelchairCompanions"
          data-testid="wheelchairCompanions"
          validationState={errors.wheelchairCompanions ? 'error' : ''}
          max={MAX_NUMBER_OF_WHEELCHAIR_COMPANIONS}
        />
      </Field>
    ) : (
      <Field>
        <Label htmlFor="nonWheelchairCompanions">
          <FormattedMessage id="addPassengers.nonWheelchairCompanions" />
        </Label>
        <StyledInput
          {...register('nonWheelchairCompanions', {
            validate: (value) => !value || (isValidPassengersNumber(value) && Number(value) <= MAX_NUMBER_OF_NON_WHEELCHAIR_COMPANIONS)
          })}
          type="number"
          inputMode="numeric"
          id="nonWheelchairCompanions"
          data-testid="nonWheelchairCompanions"
          validationState={errors.nonWheelchairCompanions ? 'error' : ''}
          max={MAX_NUMBER_OF_NON_WHEELCHAIR_COMPANIONS}
        />
      </Field>
    )}
  </>
);

SpecialAssistanceBooking.propTypes = {
  register: PropTypes.func,
  errors: PropTypes.shape({
    wheelchairCompanions: PropTypes.string,
    nonWheelchairCompanions: PropTypes.string
  }),
  hasWheelchairPassenger: PropTypes.bool,
  hasWheelchairCompanion: PropTypes.bool
};

export default SpecialAssistanceBooking;
